import { Injectable } from '@angular/core';
import { FormControl, FormGroup, FormRecord, Validators } from '@angular/forms';

import { ValidatorsService } from '@connect-services/client/services/validators.service';
import { CreateLayerDto } from '@connect-services/src/sdk/api';
import { FormService } from '@shared/client/services/form.service';

export type CreateLayerDtoWithoutProject = Omit<CreateLayerDto, 'project'>;

class AddLayerFormGroup extends FormGroup<{
    businessIdentifier: FormControl<string | null>;
    isVisible: FormControl<boolean>;
    name: FormControl<string>;
    order: FormControl<number>;
    versionLock: FormControl<boolean>;
}> {}

export class LayerFormRecord extends FormRecord<AddLayerFormGroup> {}

@Injectable({
    providedIn: 'root',
})
export class LayerCreationFormService {
    public createFormWithUniqueId(
        layersByUniqueId: { [uniqueId: string]: CreateLayerDtoWithoutProject },
        previousFormRecord?: LayerFormRecord,
    ): LayerFormRecord {
        const formRecord = new LayerFormRecord({});

        Object.keys(layersByUniqueId).forEach((uniqueId: string) => {
            formRecord.addControl(
                uniqueId,
                previousFormRecord?.controls[uniqueId] ?? this.createFormGroup(layersByUniqueId[uniqueId]),
            );
        });

        return formRecord;
    }

    private createFormGroup(layer: CreateLayerDtoWithoutProject): AddLayerFormGroup {
        return new AddLayerFormGroup({
            businessIdentifier: new FormControl(layer.businessIdentifier ?? null),
            isVisible: new FormControl(layer.isVisible ?? true, { nonNullable: true }),
            name: new FormControl(layer.name ?? '', {
                nonNullable: true,
                validators: ValidatorsService.stringValidationForm({
                    maxLength: FormService.VARCHAR_COMMON_LENGTH,
                    minLength: FormService.VARCHAR_MIN_LENGTH,
                }),
            }),
            order: new FormControl(layer.order ?? 1, { nonNullable: true, validators: [Validators.min(1)] }),
            versionLock: new FormControl(layer.versionLock ?? false, { nonNullable: true }),
        });
    }
}
